import { render, staticRenderFns } from "./gtr-media-viewer.vue?vue&type=template&id=a7e671c4&"
import script from "./gtr-media-viewer.ts?vue&type=script&lang=ts&"
export * from "./gtr-media-viewer.ts?vue&type=script&lang=ts&"
import style0 from "./gtr-media-viewer.vue?vue&type=style&index=0&id=a7e671c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports